import { render, staticRenderFns } from "./SchoolsData.vue?vue&type=template&id=39f1e134"
import script from "./SchoolsData.vue?vue&type=script&lang=js"
export * from "./SchoolsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports